export const dashboardPage = {
	heading: { sv: "Starta nytt företag eller bli företagskund" },

	title: {
		sv: "Hej {0}!",
	},
	subDescription1: {
		sv: "Här kan du starta företag eller ansöka om att bli företagskund med ett befintligt företag.",
	},
	subDescription2: {
		sv: "Du kan också följa status på dina ansökningar fram tills allt är klart.",
	},
	// todo: temporary
	subDescriptionNewCompanyDisabled: {
		sv: "Här kan du ansöka om att bli företagskund. Du kan också följa status på dina ansökningar fram tills dess att allt är klart.",
	},
	noExistingCompanies: {
		sv: "Vi hittade inga företag som du kan bli kund med. Stämmer inte informationen? Kontakta Bolagsverket för uppdatering eller välj att starta nytt företag med Svea Bank.",
	},
	// todo: temporary
	noExistingCompaniesNewCompanyDisabled: {
		sv: "Vi hittade inga företag som du kan bli kund med. Stämmer inte informationen? Kontakta Bolagsverket för uppdatering.",
	},
	newCompanyTitle: {
		sv: "Starta företag",
	},
	existingCompanyTitle: {
		sv: "Bli företagskund",
	},
	newCompanyDescription: {
		sv: `
- Börja i tjänsten Starta bolag hos oss eller på [Verksamt.se](https://verksamt.se) 
- Ansök på båda ställen och lämna samma uppgifter till oss och Verksamt.se, oavsett var du börjar.  
- När ditt nya företag är registrerat blir du automatiskt företagskund. 

Använd mejladressen **bankintyg@svea.com** i steget om bankintyg hos Verksamt.se.`,
	},
	campaign: {
		content: {
			sv: "Vi meddelar när du ska betala in företagets aktiekapital (minst 25 000 kr) och avgift för bankintyg",
		},
		regularPrice: {
			sv: "Ordinaire pris",
		},
		currentPrice: {
			sv: "Just nu 0 kr",
		},
	},
	existingCompanyDescription: {
		sv: "Här visar vi företag kopplade till dig enligt Bolagsverket. Det är aktiebolag, handelsbolag och enskilda firmor. Du kan också se de företag som redan är kunder i Svea Bank.",
	},
	newCompanyButtonText: {
		sv: "Starta nytt företag",
	},
	newCompanyVerksamtText: {
		sv: "Har du inte ansökt på Verksamt.se redan – använd samma uppgifter som du skickade in till oss. Smidigt!",
	},
	newCompanySummaryLink: {
		sv: "Visa uppgifterna i ansökan",
	},
	existingCompanyButtonText: {
		sv: "Påbörja ansökan",
	},
	newApplicationModal: {
		title: {
			sv: "Så här går det till",
		},
		creditAlert: {
			title: {
				sv: "Kreditbedömning ingår i ansökan",
			},
			content: {
				sv: "Vi gör en kreditbedömning som en del av ansökan. Därför hämtar vi en kreditupplysning på dig som driver den enskilda firman.",
			},
		},
		content: {
			sv: `Vi hämtar information om företaget från Bolagsverket. Kontrollera att allt stämmer och
        välj vilka banktjänster ni vill ha. Därefter bekräftar du beställningen med hjälp av
        BankID. Om er firmateckningsstruktur kräver det, behöver även de andra parterna signera
        med BankID. \n\nI sista steget svarar du på frågor om ditt företag och de affärer ni planerar att göra i
        banken - frågor vi som bank måste ställa enligt lag. Sen är du klar och kan börja använda
        tjänsterna direkt.`,
		},

		infoBoxTitle: {
			sv: "Det här behöver du",
		},
		infoItem1: { sv: "Mejladress till företagets firmatecknare" },
		infoItem2: {
			sv: "Uppdaterade uppgifter om verklig huvudman på Bolagsverket",
		},
		infoItem3: {
			sv: "Alla som ska signera avtal behöver ha tillgång till BankID",
		},
		start: { sv: "Kom igång" },
	},
	newCompanyModal: {
		modalHeading: {
			sv: "Starta företag",
		},
		modalSubHeading: {
			sv: "Så här går det till",
		},
		initButtonText: {
			sv: "Påbörja ansökan",
		},
	},
	invalidApplicantModal: {
		title: {
			sv: "Du kan inte ansöka",
		},
		body: {
			sv: "Du kan inte påbörja en ansökan. För att du ska bli kund i banken behöver en firmateckare ansöka.",
		},
	},
	applications: {
		newCompanyApplication: {
			noCompanyName: {
				sv: "Inget företagsnamn",
			},
			noOrgNr: {
				sv: "Inget organisationsnummer",
			},
		},
		statuses: {
			ongoing: {
				sv: "Ansökan påbörjad",
			},
			finalized: {
				sv: "Ansökan inskickad",
			},
			isCustomer: {
				sv: "Kund i Svea Bank",
			},
		},
		statusDescriptions: {
			agreementsToSign: {
				sv: "Du behöver signera ett eller flera avtal.",
			},
			beneficialOwnerDeclined: {
				sv: "Väntar på information om verklig huvudman.",
			},
			signOther: {
				sv: "Vi väntar på övriga signaturer som behövs.",
			},
			manualHandling: {
				sv: "Vi kontaktar dig när vi granskat den.",
			},
			readyForFinalize: {
				sv: "Allt är klart - skicka in ansökan.",
			},
		},
	},
	preselectedPackage: {
		"FÖRETAGARNA-BAS": {
			title: {
				sv: "För dig som är medlem i Företagarna",
			},
			description: {
				sv: "Så här skaffar du medlemspaketet med banktjänster:",
			},
			text1: {
				sv: "Påbörja ansökan med ditt företag under Bli företagskund i Svea",
			},
			text2: {
				sv: "Medlemspaketet är redan förvalt för dig som är medlem i Företagarna",
			},
		},

		"FORETAGARNA-CARDONLY": {
			title: {
				sv: "För dig som är medlem i Företagarna",
			},
			description: {
				sv: "Så här skaffar du Företagarna kreditkort:",
			},
			text1: {
				sv: "Påbörja ansökan med ditt företag under Bli företagskund i Svea",
			},
			text2: {
				sv: "Kreditkortet är redan förvalt för dig som är medlem i Företagarna",
			},
		},

		"BAAS-FÖRETAG-VÄXA": {
			title: {
				sv: "Kreditutrymme för att anställa och investera",
			},
			description: {
				sv: "Skaffa företagspaketet Växa så här:",
			},
			text1: {
				sv: "Påbörja ansökan med ditt företag under Bli företagskund i Svea",
			},
			text2: {
				sv: "När du kommer till nästa steg är företagspaketet Växa redan förvalt",
			},
		},

		"BAAS-FÖRETAG-BAS": {
			title: {
				sv: "De viktigaste banktjänsterna för startup och småföretagare",
			},
			description: {
				sv: "Skaffa företagspaketet Bas så här:",
			},
			text1: {
				sv: "Påbörja ansökan med ditt företag under Bli företagskund i Svea",
			},
			text2: {
				sv: "När du kommer till nästa steg är företagspaketet Bas redan förvalt",
			},
		},

		"E-HANDEL-BAS": {
			title: {
				sv: "Svea Checkout betallösning och banktjänster",
			},
			description: {
				sv: "Skaffa företagspaketet E-handel så här:",
			},
			text1: {
				sv: "Påbörja ansökan med ditt företag under Bli företagskund i Svea",
			},
			text2: {
				sv: "När du kommer till nästa steg är företagspaketet E-handel redan förvalt",
			},
		},
	},

	promotions: {
		creditInterest: {
			title: {
				sv: "Bli kund och få ränterabatt fram till 31 mars",
			},
			text: {
				sv: "Du som blir företagskund innan årets slut får ränterabatt på kontokredit och kreditkort till sista mars. Vi erbjuder upp till 35 % ränterabatt på kontokredit och upp till 21 % på kreditkort vid delbetalning. I vårt populära företagspaket Växa ingår båda produkterna.",
			},
			notice: {
				sv: "Din individuella ränterabatt beräknas och aktiveras automatiskt när du ansöker under kampanjperioden 1 oktober – 31 december 2026.",
			},
		},
	},
};
